export default __webpack_public_path__ + "static/media/hammer.1cad02e9.png";